export const mutations = {
  UPDATE_SEARCH_KEY (state, value) {
    state.searchKey = value;
  }
};
